import React from "react";
import { Bar } from "react-chartjs-2";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function TestHorizontalBar() {

    // ---- TEST DATA (so chart never stays blank) ----
    const labels = ["Pune", "Nagpur", "Nashik", "Thane", "Aurangabad"];
    const values = [120, 104, 97, 88, 75];

    const data = {
        labels,
        datasets: [
            {
                label: "Infant Deaths",
                data: values,
                backgroundColor: "#5e72e4",       // Argon primary
                borderRadius: 8,
                barThickness: 20,
            }
        ]
    };

    const options = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: {
                    color: "#334155",
                    font: { size: 12 }
                },
                grid: { color: "rgba(0,0,0,0.05)" }
            },
            y: {
                ticks: {
                    color: "#334155",
                    font: { size: 12, weight: "500" }
                },
                grid: { display: false }
            },
        },
        plugins: {
            legend: { display: false },
            tooltip: {
                backgroundColor: "#ffffff",
                titleColor: "#1e293b",
                bodyColor: "#1e293b",
                borderColor: "#e2e8f0",
                borderWidth: 1,
                cornerRadius: 10,
                displayColors: false,
            },
            datalabels:false
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-md p-4 ">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">Top Infant Death Districts</h3>

            {/* FIXED HEIGHT */}
            <div className="h-[300px]">
                <Bar data={data} options={options} />
            </div>
        </div>
    );
}
